module.exports = __webpack_public_path__ + "static/assets/fe4806d6cb1e9329484187da24742424.svg";